import { HashRouter, Route, Routes } from "react-router-dom";
import Auth from "./services/Auth";
import PrivateRoute from "./security/PrivateRoute";

import Login from "./pages/login/Login";
import Forgot from "./pages/login/Forgot";
import Reset from "./pages/login/Reset";
import Register from "./pages/login/Register";

import Shop from "./pages/shop/Index";
import Item from "./pages/shop/Item";

// Settings
import Account from "./pages/settings/account/Index";
import Users from "./pages/settings/users/Index";
import UsersView from "./pages/settings/users/UserView";

import Orders from "./pages/settings/orders/Index";
import OrdersView from "./pages/settings/orders/OrderView";

import Partners from "./pages/settings/partners/Index";
import PartnersForm from "./pages/settings/partners/Form";

import Items from "./pages/settings/items/Index";
import ItemCreateForm from "./pages/settings/items/Create";
import ItemEditForm from "./pages/settings/items/Edit";

import Categories from "./pages/settings/categories/Index";
import CategorieForm from "./pages/settings/categories/Form";

import { setUser } from "./features/auth/authSlice";
import { useDispatch } from "react-redux";

Auth.setup();

function App() {
  const dispatch = useDispatch();
  dispatch(setUser(Auth.isAuthenticated()));

  return (
    <HashRouter>
      <Routes>
        {/* Settings */}

        <Route
          exact
          path="/settings/account"
          element={<PrivateRoute permissions={["ROLE_ADMIN", "ROLE_USER"]} />}
        >
          <Route exact path="/settings/account" element={<Account />} />
        </Route>

        <Route
          exact
          path="/settings/users"
          element={<PrivateRoute permissions={["ROLE_ADMIN"]} />}
        >
          <Route exact path="/settings/users" element={<Users />} />
        </Route>

        <Route
          exact
          path="/settings/users/:id"
          element={<PrivateRoute permissions={["ROLE_ADMIN"]} />}
        >
          <Route exact path="/settings/users/:id" element={<UsersView />} />
        </Route>

        <Route
          exact
          path="/settings/partners"
          element={<PrivateRoute permissions={["ROLE_ADMIN"]} />}
        >
          <Route exact path="/settings/partners" element={<Partners />} />
        </Route>

        <Route
          exact
          path="/settings/partners/:id"
          element={<PrivateRoute permissions={["ROLE_USER"]} />}
        >
          <Route
            exact
            path="/settings/partners/:id"
            element={<PartnersForm />}
          />
        </Route>

        <Route
          exact
          path="/settings/items"
          element={<PrivateRoute permissions={["ROLE_ADMIN", "ROLE_USER"]} />}
        >
          <Route exact path="/settings/items" element={<Items />} />
        </Route>

        <Route
          exact
          path="/settings/items/create"
          element={<PrivateRoute permissions={["ROLE_ADMIN", "ROLE_USER"]} />}
        >
          <Route
            exact
            path="/settings/items/create"
            element={<ItemCreateForm />}
          />
        </Route>

        <Route
          exact
          path="/settings/items/:id"
          element={<PrivateRoute permissions={["ROLE_USER"]} />}
        >
          <Route exact path="/settings/items/:id" element={<ItemEditForm />} />
        </Route>

        <Route
          exact
          path="/settings/categories"
          element={<PrivateRoute permissions={["ROLE_ADMIN"]} />}
        >
          <Route exact path="/settings/categories" element={<Categories />} />
        </Route>
        <Route
          exact
          path="/settings/categories/:id"
          element={<PrivateRoute permissions={["ROLE_ADMIN"]} />}
        >
          <Route
            exact
            path="/settings/categories/:id"
            element={<CategorieForm />}
          />
        </Route>

        <Route
          exact
          path="/"
          element={<PrivateRoute permissions={["ROLE_USER"]} />}
        >
          <Route exact path="/" element={<Shop />} />
        </Route>
        <Route
          exact
          path="/items/:id"
          element={<PrivateRoute permissions={["ROLE_USER"]} />}
        >
          <Route exact path="/items/:id" element={<Item />} />
        </Route>

        <Route
          exact
          path="/settings/orders"
          element={<PrivateRoute permissions={["ROLE_USER"]} />}
        >
          <Route exact path="/settings/orders" element={<Orders />} />
        </Route>

        <Route
          exact
          path="/settings/orders/:id"
          element={<PrivateRoute permissions={["ROLE_USER"]} />}
        >
          <Route exact path="/settings/orders/:id" element={<OrdersView />} />
        </Route>

        <Route exact path="/login" element={<Login />} />
        <Route exact path="/forgot" element={<Forgot />} />
        <Route exact path="/register" element={<Register />} />
        <Route exact path="/reset/:token" element={<Reset />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
